import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../environments/environment';
import {MasterSheetFilter} from './masterSheetFilter';
import * as moment from 'moment';
import {finalize} from 'rxjs/operators';
import {BehaviorSubject, Observable} from 'rxjs';
import {InvoiceAddendumListViewModel, InvoiceAddendum} from './invoiceAddendumListViewModel';
import { FileDownloadService } from 'src/app/services/file-download.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  public masterSheetFilter = new MasterSheetFilter();

  public invoiceAddendumList$ = new BehaviorSubject<InvoiceAddendumListViewModel[]>([]);

  private _top = 5;

  constructor(public http: HttpClient,
              public toast: ToastrService,
              private fileDownload : FileDownloadService) {

  }

  public emailInvoices(param: any) {

    return this.http.post(environment.baseURl + `/api/invoice/emailinvoices`, param);
  }

  public sendMasterSheet(toEmail: string, fromDate: moment.Moment, toDate: moment.Moment, isComish : boolean) {

    const data = {
      toEmail: toEmail,
      fromDate: fromDate,
      toDate: toDate,
      isCommissionReport : isComish
    };

    return this.http.post(environment.baseURl + `/api/invoice/sendmastersheet`, data);
  }

  public upload(formData): Observable<any> {

    return this.http.post<any>(environment.baseURl + `/api/invoice/uploadaddendum`, formData, {
      reportProgress: true,
      observe: 'events',

    }).pipe(finalize(() => {
      this.getInvoiceAddendumList();
    }));
  }

  public getInvoiceAddendumList(top?: number): void {

    if (top) {
      this._top = top;
    }
    this.http.get<InvoiceAddendumListViewModel[]>(environment.baseURl + `/api/invoice/getInvoiceAddendumLMasterList/${this._top}`).subscribe((r: InvoiceAddendumListViewModel[]) => {
      this.invoiceAddendumList$.next(r);
    });
  }

  public deleteInvoiceAddendum(date: Date): Observable<any> {
    return this.http.delete(environment.baseURl + `/api/invoice/deleteaddendum/${date}`).pipe(finalize(() => {
      this.getInvoiceAddendumList();
    }));
  }

  public saveInvoiceAddendum(addy : InvoiceAddendum){
    return this.http.post(environment.baseURl+`/api/invoice/addendum/save`, addy);
  }

  public getInvoiceHistoryMonthAndYears() : Observable<any>{
    return this.http.get<any>(environment.baseURl + `/api/invoice/getInvoiceHistoryDates`);
  }

  public downloadAccountingReport(month:number,year:number): Observable<Blob> {
    return this.http.post(environment.baseURl + `/api/invoice/accountingreport`, { month:month,year:year},{ responseType: 'blob' } );
  }

  public downloadResmanReport(month:number,year:number): Observable<Blob> {
    return this.http.post(environment.baseURl + `/api/invoice/resman`, { month:month,year:year},{ responseType: 'blob' } );
  }

  public downloadInvoices(toDate : moment.Moment, fromDate : moment.Moment) {
    return this.http.post(environment.baseURl + '/api/invoice/download', { toDate: toDate, fromDate: fromDate }, { responseType: 'blob' });
  }
  public downloadAutoPaymentCSV(month: number, year: number) {
    return this.http.post(environment.baseURl + `/api/invoice/autopayreport`, { month: month, year: year }, { responseType: 'blob' });
  } 

  public downloadOneTimePaymentCSV(month: number, year: number) {
    return this.http.post(environment.baseURl + `/api/invoice/one-time-payments-report`, { month: month, year: year }, { responseType: 'blob' });
  } 

  public downloadCourtFeesCSV() {
    return this.http.get(environment.baseURl + '/api/invoice/courtfees', { responseType: 'blob' });
  }
}


